export default "__VITE_ASSET__0e855b0d__"